module Tapas.Bindings {
    export class LoadSubGroup {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var data = new Ftw.Data();
			var ele = $(element);

			ele.click(function (e) {
				var parentElement = document.getElementById(valueAccessor().parent);
				$(parentElement).addClass("load");

                //data.get(window.location.origin + "/" + valueAccessor().href + "&LayoutTemplate=Designs/Tapas/ajax_page.cshtml&ajaxTapas=true")
                data.get(window.location.origin + "/" + valueAccessor().href + "&TopPageID=" + valueAccessor().toppageid + "&LayoutTemplate=Designs/Tapas/ajax_page.cshtml&ajaxTapas=true")
				.then((data) => {
					var subGroupHtml = $(data).html();
					var subGroupNumber = $(data).children().attr("id");
					$(parentElement).after(subGroupHtml).removeClass("active").delay(200).fadeOut(0);
					$("#" + subGroupNumber + ".setSubmenu").fadeIn(200);
					ko.applyBindings(viewModel, document.getElementById(subGroupNumber));
				})
				.finally(() => {
					$(parentElement).removeClass("load");
				});

				e.stopPropagation();
			});
        }
    }
    ko.bindingHandlers['loadSubGroup'] = new LoadSubGroup();
}